export default {
	loading: "Chargement de l'agenda...",
	unavailable: "Agenda indisponible",
	unavailableHint:
		"Ce lien a peut-être expiré ou l'agenda a été désactivé par le temple.",
	empty: "Aucun rituel publié pour le moment.",
	upcoming: "Prochains rituels",
	tabs: {
		calendar: "Calendrier",
		info: "Plus d’informations",
	},
	info: {
		about: "À propos de la maison",
		address: "Adresse",
		contact: "Contact",
		phone: "Téléphone",
		whatsapp: "WhatsApp",
		email: "E-mail",
		social: "Réseaux sociaux",
	},
	reserve: "Réserver une place",
	full: "Complet",
	dialog: {
		title: "Réserver une place",
		subtitle: "Remplissez vos coordonnées pour réserver à ce rituel.",
		name: "Votre nom",
		phone: "Téléphone",
		email: "E-mail",
		notes: "Remarque (optionnel)",
		photo: {
			label: "Photo",
			capture: "Prendre une photo",
			retake: "Reprendre",
		},
		consent: "J'autorise le temple à utiliser mes coordonnées pour cette réservation.",
		consentWithPhoto:
			"J'autorise le temple à utiliser mes coordonnées et la photo prise à l'instant pour cette réservation.",
		submit: "Envoyer la réservation",
		cancel: "Annuler",
	},
	validation: {
		nameRequired: "Saisissez votre nom",
		phoneRequired: "Saisissez votre téléphone",
		emailRequired: "Saisissez votre e-mail",
		emailInvalid: "E-mail invalide",
		consentRequired: "Vous devez autoriser pour réserver",
		photoRequired: "Prenez une photo pour terminer la réservation",
	},
	success: {
		title: "Réservation reçue !",
		message: "Nous avons reçu votre réservation. Le temple l'examinera et vous recontactera.",
		close: "Fermer",
	},
	error: "Nous n'avons pas pu envoyer votre réservation. Veuillez réessayer.",
	poweredBy: "Agenda par ORI",
	tracking: {
		title: "Votre réservation",
		statusPendingConfirmation: "Confirmez votre réservation",
		statusPendingReview: "En attente d'examen du temple",
		statusApproved: "Réservation confirmée",
		statusRejected: "Réservation refusée",
		statusCancelled: "Réservation annulée",
		confirmHint: "Cliquez ci-dessous pour confirmer votre présence à ce rituel.",
		reviewHint: "Nous avons reçu votre confirmation. Le temple l'examinera et vous contactera.",
		approvedHint: "C'est fait ! Votre présence est confirmée.",
		confirm: "Confirmer la réservation",
		cancel: "Annuler la réservation",
		confirmed: "Réservation confirmée !",
		cancelled: "Réservation annulée.",
		error: "Impossible de terminer. Veuillez réessayer.",
		notFound: "Réservation introuvable.",
	},
};
